export class DeliverySheetSizeHelper {
    constructor(productItem) {
        this.productItem = productItem;
    }
    minimizeWidth() {
        var _a;
        const stickerWidth = (_a = this.productItem.getAttribute('width_mm')) !== null && _a !== void 0 ? _a : 0;
        const cols = Math.floor(this.sheetWidth / (this.insidePadding + stickerWidth + this.insidePadding));
        const newWidth = cols * (this.insidePadding + stickerWidth + this.insidePadding) + 2 + this.outsidePadding + this.outsidePadding;
        this.productItem.setAttribute('delivery_sheet_width', newWidth);
    }
    minimizeHeight() {
        var _a;
        const stickerHeight = (_a = this.productItem.getAttribute('height_mm')) !== null && _a !== void 0 ? _a : 0;
        const rows = Math.floor(this.sheetHeight / (this.insidePadding + stickerHeight + this.insidePadding));
        const newHeight = rows * (this.insidePadding + stickerHeight + this.insidePadding) + 2 + this.outsidePadding + this.outsidePadding;
        this.productItem.setAttribute('delivery_sheet_height', newHeight);
    }
    setDefaultValues() {
        this.productItem.setAttribute('delivery_sheet_width', DeliverySheetSizeHelper.WIDTH_DEFAULT);
        this.productItem.setAttribute('delivery_sheet_height', DeliverySheetSizeHelper.HEIGHT_DEFAULT);
        this.productItem.setAttribute('delivery_sheet_inside_padding', DeliverySheetSizeHelper.INSIDE_PADDING_DEFAULT);
        this.productItem.setAttribute('delivery_sheet_outside_padding', DeliverySheetSizeHelper.OUTSIDE_PADDING_DEFAULT);
    }
    get sheetHeight() {
        return this.toFixedInt(this.productItem.getAttribute('delivery_sheet_height'));
    }
    get sheetWidth() {
        return this.toFixedInt(this.productItem.getAttribute('delivery_sheet_width'));
    }
    get insidePadding() {
        return this.toFixedInt(this.productItem.getAttribute('delivery_sheet_inside_padding'));
    }
    get outsidePadding() {
        return this.toFixedInt(this.productItem.getAttribute('delivery_sheet_outside_padding'));
    }
    toFixedInt(value) {
        const fixedValue = parseInt(Number(value).toFixed(0));
        return isNaN(fixedValue) ? 0 : fixedValue;
    }
}
DeliverySheetSizeHelper.WIDTH_DEFAULT = 204;
DeliverySheetSizeHelper.HEIGHT_DEFAULT = 270;
DeliverySheetSizeHelper.WIDTH_MINIMUM = 25;
DeliverySheetSizeHelper.HEIGHT_MINIMUM = 25;
DeliverySheetSizeHelper.INSIDE_PADDING_DEFAULT = 2;
DeliverySheetSizeHelper.OUTSIDE_PADDING_DEFAULT = 0;
